import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../../../core/service/base/his-ui.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

type Option = {
    key: string;
    value: string;
    label: string;
    name: string;
    sortorder: number;
};

type SelectOneJobSetting = {
    value: string | Option[];
    label: string;
    helptext?: string;
    required: boolean;
    options: Option[];
    selectedValue?: string;
    readonly: boolean;
    name: string;
};

@Component( {
    selector: 'his-select-one-job-setting',
    templateUrl: './his-select-one-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisSelectOneJobSettingComponent {
    private uiTextService = inject(HisUiService);
    private baseGlobalService = inject( HisBaseGlobalsService );

    /* Property für das gerade bearbeitete Setting */
    private settingValue: SelectOneJobSetting;
    @Input({required:true}) get setting() {
        return this.settingValue;
    }
    set setting( value: SelectOneJobSetting ) {
        this.settingValue = value;
        this.copySettingToSelection();
    }

    private allItems: Option[];
    protected filteredItems: Option[] = [];

    /* Property für das ausgewählte Item*/
    private selectedItemValue: Option;
    protected get selectedItem(): Option {
        return this.selectedItemValue;
    }

    protected get title() {
        if ( this.baseGlobalService.system.operationMode !== 'cust' ) {
            return '';
        }
        return this.setting.name;
    }

    protected set selectedItem( value: string | Option ) {
        let selection: string | Option = value;
        if ( typeof selection === 'string' ) {
            // wenn der Wert ein String ist, dann ist es der key des Items
            selection = this.allItems.find( item => item.key === value );
        }
        this.selectedItemValue = selection;
        this.copySelectionToSetting();
    }

    protected copySelectionToSetting() {
        if ( !this.selectedItem ) {
            return;
        }
        const selectedItem = this.allItems.find( item => item.key === this.selectedItem.key );
        if ( !selectedItem ) {
            return;
        }
        this.setting.value = selectedItem.key;
        this.setting.selectedValue = selectedItem.value;
    }

    protected copySettingToSelection() {
        if ( this.setting && this.setting.options ) {
            this.assureItemsAreAssembled();

            let foundItem = null;
            for ( let item of this.allItems ) {
                // setting.value bezieht sich auf den key in den options - das ist etwas schräg.
                if ( item.key === this.setting.value ) {
                    foundItem = item;
                    break;
                }
            }
            this.selectedItem = foundItem;
            if ( foundItem ) {
                // da setting.value dem key der option entspricht, brauchen wir für den option.value ein neues Feld
                this.setting.selectedValue = foundItem.value;
            }
        }
    }

    private assureItemsAreAssembled() {
        if ( this.allItems ) {
            return;
        }

        const allItems = [];
        for ( let option of this.setting.options ) {
            let theLabel = this.uiTextService.translate( option.label );
            if ( theLabel.startsWith( '???' ) ) {
                theLabel = option.label;
            }
            const item = option;
            item.label = theLabel;
            allItems.push( item );
        }
        this.allItems = allItems;
    }

    protected filterItems( event: AutoCompleteCompleteEvent ) {
        this.assureItemsAreAssembled();
        const filteredItems = [];
        for ( let item of this.allItems ) {
            if ( item.label.toLowerCase().indexOf( event.query.toLowerCase() ) === 0 ) {
                filteredItems.push( item );
            }
        }
        this.filteredItems = filteredItems;
    }
}
